import { render, staticRenderFns } from "./DocumentsRegistration.vue?vue&type=template&id=44ea75f2&scoped=true"
import script from "./DocumentsRegistration.vue?vue&type=script&lang=ts"
export * from "./DocumentsRegistration.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsRegistration.vue?vue&type=style&index=0&id=44ea75f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ea75f2",
  null
  
)

/* custom blocks */
import block0 from "./document.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3385412112%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fdocuments%2FDocumentsRegistration.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./document.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3385412112%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fdocuments%2FDocumentsRegistration.vue&external"
if (typeof block1 === 'function') block1(component)
import block2 from "./horseType.fr.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3385412112%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fdocuments%2FDocumentsRegistration.vue&external"
if (typeof block2 === 'function') block2(component)
import block3 from "./horseType.en.json?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3385412112%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fdocuments%2FDocumentsRegistration.vue&external"
if (typeof block3 === 'function') block3(component)

export default component.exports